import type { ConversationErrorStatus } from '@mote/api'

export function isAnonymousMoteExpiredError(
  response: Response,
  json: ConversationErrorStatus | null
) {
  return (
    response.status === 412 &&
    json !== null &&
    'visibilityContext' in json &&
    json.visibilityContext === 'anonymous'
  )
}

export function isAnonymousMoteDeletedError(
  response: Response,
  json: ConversationErrorStatus | null
) {
  return (
    response.status === 410 &&
    json !== null &&
    'moteContext' in json &&
    json.moteContext === 'anonymous'
  )
}
